const root = 'orderShippingAddressModal'

export const TestId = {
  companyName: 'companyName',
  name: 'name',
  street: 'address',
  city: 'city',
  state: 'state',
  zipCode: 'zipCode',
  country: 'country',
  phone: 'phone',
  submitButton: `${root}-submitButton`,
}
